module.exports = __webpack_public_path__ + "img/ic_design_item5.73df8131.png";